import script from "./released-product-list.vue?vue&type=script&setup=true&lang=js"
export * from "./released-product-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__